import React from "react";
import { Box, Container, Typography } from "@mui/material";

const SmallMsg = () => {
  return (
    <Box
      component="section"
      sx={{
        py: { xs: 8, md: 10 },
        background: "var(--primary-color)",
        position: "relative",
        overflow: "hidden",
      }}
    >
      {/* Decorative background shapes */}
      <Box
        sx={{
          position: "absolute",
          top: -50,
          left: -50,
          width: 200,
          height: 200,
          borderRadius: "50%",
          background: "rgba(255, 255, 255, 0.05)",
        }}
      />
      <Box
        sx={{
          position: "absolute",
          bottom: -80,
          right: -80,
          width: 300,
          height: 300,
          borderRadius: "50%",
          background: "rgba(255, 255, 255, 0.03)",
        }}
      />

      <Container maxWidth="md">
        <Typography
          variant="h3"
          sx={{
            fontWeight: 400,
            color: "#fff",
            textAlign: "center",
            lineHeight: 1.5,
            fontSize: { xs: "1.5rem", md: "2.2rem" },
            fontFamily: "'Roboto Slab', serif",
            textShadow: "0 2px 4px rgba(0,0,0,0.1)",
          }}
        >
          Inspiring <span style={{ fontWeight: 700 }}>progress</span> through
          innovation, collaboration, and a commitment to{" "}
          <span style={{ fontWeight: 700 }}>lasting impact</span>.
        </Typography>
      </Container>
    </Box>
  );
};

export default SmallMsg;
